import { render, staticRenderFns } from "./GerenciamentoTransporteDetalhes.vue?vue&type=template&id=4e97b1cd"
import script from "./GerenciamentoTransporteDetalhes.vue?vue&type=script&lang=js"
export * from "./GerenciamentoTransporteDetalhes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports